
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/secondhomes",
      function () {
        return require("private-next-pages/secondhomes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/secondhomes"])
      });
    }
  